const config = {
  gatsby: {
    pathPrefix: '/',
    assetPrefix: 'gatsby',
    siteUrl: 'http://compute.procedural.build',
    trailingSlash: false,
  },
  header: {
    logo: 'https://procedural-business.s3.eu-central-1.amazonaws.com/media/procedural_logo_250px.jpg',
    logoLink: 'https://compute.procedural.build',
    title: "Compute",
  },
  siteMetadata: {
    title: 'Compute',
    description: 'Documentation',
    ogImage: null,
    favicon: 'assets/images/procedural_logo_black_A4.png',
  },
};

module.exports = config;
